module.exports = __webpack_public_path__ + "static/media/interior3.903d98d0.svg";